import React from "react";

class ImageSlider extends React.Component {
  componentDidMount() {
    const $ = window.$;
    $(this.refs.imageSlider).owlCarousel({
      'items': 5,
      'navigation': true,
      'navigationText': [
        "<i class='fa fa-angle-left fa-2x'></i>",
        "<i class='fa fa-angle-right fa-2x'></i>"],
      'pagination': false
    });
  }
  render() {
    return (
        <section className="section instagram" style={{background: "#ffffff", padding: "60px 0"}}>

          <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h1 className="Title m-0">Follow Us On</h1>
                <p>Anywhere and Anytime. Use your Mighty wherever and whenever you need it</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12" style={{padding: "30px 0 0 0"}}>
              <div id="image-slider-carousel" ref="imageSlider" className="owl-carousel owl-carousel-full">

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-1.jpg" alt="Mightywifi US and Global hotspot wifi device gaming image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-1.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-2.jpg" alt="Mightywifi US and Global hotspot wifi device coffee image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-2.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-3.jpg" alt="Mightywifi US and Global hotspot wifi device travel image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-3.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-4.jpg" alt="Mightywifi US and Global hotspot wifi device home image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-4.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-5.jpg" alt="Mightywifi US and Global hotspot wifi device home image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-5.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-6.jpg" alt="Mightywifi US and Global hotspot wifi device home image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-6.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-item">
                  <div className="image-slider">
                    <div className="image-slider-item">
                      <a href="#">
                        <img src="../images/instagram-7.jpg" alt="Mightywifi US and Global hotspot wifi device home image" />
                      </a>
                      <div className="image-slider-overlay">
                        <a href="../images/instagram-7.jpg" className="center-icon" data-lightbox="image"><i
                            className="fa fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          </div>

        </section>
  );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/layout/ImageSlider.js